<div class="result-banner" [attr.data-type]="type()">
  <mat-icon>{{ icon }}</mat-icon>
  <span>{{ message() }}</span>
</div>
